import "./Architecture.css";
import ContentPopUp from "../../components/ContentPopUp/ContentPopUp";
import { useState } from "react";
import Lines from "../../components/Lines/Lines";
import data from "../../Data/diagramData.json";
import Layer from "../../components/Layer/Layer";
import JourneyBox from "../../components/JourneyBox/JourneyBox";

const Architecture = () => {
  const [selectedNode, setSelectedNode] = useState(null);
  const [selectedJourney, setSelectedJourney] = useState(null);

  return (
    <div className="flex_box">
      <div className="container-box">
        <h1>{data.title}</h1>
        <div className="main-box">
          <div className="side-pannel">
            <JourneyBox
              selectedJourney={selectedJourney}
              setSelectedJourney={setSelectedJourney}
              setSelectedNode={setSelectedNode}
            />
            <ContentPopUp
              selectedNode={selectedNode}
              setSelectedNode={setSelectedNode}
              selectedJourney={selectedJourney}
            />
          </div>

          <div className="diagram-box">
            <Lines selectedJourney={selectedJourney} />
            {data.layers.map((layer, index) => {
              return (
                <Layer
                  key={index}
                  layerData={layer.block}
                  selectedNode={selectedNode}
                  setSelectedNode={setSelectedNode}
                  selectedJourney={selectedJourney}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Architecture;
